<template>
    <el-dialog :visible.sync="popupModal" width="508px" top="16vh" :title="$t('operation.rule.industry')">
        <el-form :model="ruleForm" :rules="rules" ref="modalForm" label-width="140px" style="width: 450px;">
            <el-form-item :label="$t('operation.rule.industryName') + '：'" key="name" prop="name">
                <el-input :placeholder="$t('common.inputplaceholder')" v-model="ruleForm.name" size="medium"
                    maxlength="32"></el-input>
            </el-form-item>

            <div class="content-table" style="height: 400px;overflow-y: auto;">
                <el-table :data="tableData" style="width: 100%" stripe empty-text=" ">
                    <el-table-column prop="industryName" :label="$t('operation.rule.industryNameList')" width="350px"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column>
                        <template slot-scope="scope">
                            <span class="error-txt" @click="clickTdDelete(scope.row, scope.$index)">{{
        $t('common.delete') }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="popupModal = false" class="sys-btn-default">{{ $t('common.cancel') }}</el-button>
            <el-button @click="saveData" type="primary">{{ $t('common.confirm') }}</el-button>
        </span>

        <ActionPwdModal ref="actionPwdRef" @actionSave="deleteData"></ActionPwdModal>
    </el-dialog>
</template>

<script>
import ActionPwdModal from '@/components/actionPwdModal.vue'
export default {
    data() {
        return {
            popupModal: false,
            ruleForm: {
                name: null,
            },
            rules: {
                name: [{ required: true, message: vm.$t('common.commontip'), trigger: 'blur' }],
            },
            monitorId: null,
            tableData: [],
            id: null,
            index: null,
        }
    },
    components: {
        ActionPwdModal
    },
    created() {

    },
    methods: {
        close() {
            this.popupModal = false;
        },
        clickTdDelete(row, index) {
            this.id = row.id;
            this.index = index;
            this.$refs.actionPwdRef.open();
        },
        deleteData(password) {
            this.$Http.post(this.$Api.checkStandardIndustryDelete + '/' + this.monitorId + '/' + this.id + '/' + password).then(res => {
                if (res.success) {
                    this.$refs.actionPwdRef.close();
                    this.tableData.splice(this.index, 1);
                    this.$emit('deleteIndustryCallBack', this.id);
                }
            });
        },
        open(monitorId, industryList) {
            this.monitorId = monitorId;
            this.popupModal = true;
            this.tableData = industryList;
            this.$nextTick(() => {
                this.$refs.modalForm.resetFields();
                this.ruleForm.name = null;
            })
        },
        saveData() {
            this.$refs.modalForm.validate((valid) => {
                if (!valid) {
                    return false;
                } else {
                    let url = `${this.$Api.checkStandardIndustryAdd}/${this.monitorId}/${this.ruleForm.name}`;
                    this.$Http.post(url).then(res => {
                        if (res.success) {
                            this.$message.success(vm.$t('common.successful'));
                            this.$emit("closeAddModal");
                        }
                    });
                }
            })
        }
    }
}
</script>